import { getPurchaseDetailsEndpoint } from '@api/fetchers/checkout';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import {
  getIsSubscribedToGoal,
  getIsSubscribedToIconic
} from '@api/selectors/subscription';
import { emptyList } from '@constants/empty';
import useFetch from '@hooks/useFetch';

const useReferralCodeSuggestions = (subscriptionUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const { data: purchaseDetails } = useFetch(
    subscriptionUID ? getPurchaseDetailsEndpoint(subscriptionUID) : null
  );

  const goalUID = purchaseDetails?.subscription?.goal?.uid || null;

  const isIconic = purchaseDetails?.subscription?.type === 5;

  const isExtendPlan = useMyInfo(getIsSubscribedToGoal(goalUID));
  const isSubscribedToIconic = useMyInfo(getIsSubscribedToIconic(goalUID));
  const isUpgrade = isExtendPlan && !isSubscribedToIconic && isIconic;

  const { data: referralCodes, ...rest } = useFetch(
    subscriptionUID && isLoggedIn
      ? `v1/subscriptions/suggest_referral_codes?subscription_uid=${subscriptionUID}&is_extend=${isExtendPlan}&is_upgrade=${isUpgrade}`
      : null
  );

  return { referralCodes: referralCodes || emptyList, ...rest };
};

export default useReferralCodeSuggestions;
